import { ApiConfig } from '@eng-dx-gpt/api-client';

/**
 * UI Manager microservice API configuration
 * All endpoints related to chatbot configuration and UI customization
 */
export const uiManagerBackendConfig: ApiConfig[] = [
  // Configuration Controller
  {
    name: 'getConfigurationById',
    method: 'GET',
    url: '/private/configuration/{id}',
    service: 'ui'
  },
  {
    name: 'deleteConfigurationById',
    method: 'DELETE',
    url: '/private/configuration/{id}',
    service: 'ui'
  },
  {
    name: 'deleteConfiguration',
    method: 'DELETE',
    url: '/private/configuration',
    service: 'ui'
  },
  {
    name: 'deleteConfigurationByMotherAgentId',
    method: 'DELETE',
    url: '/private/configuration/mother-agent/{motherAgentId}',
    service: 'ui'
  },
  {
    name: 'putConfigurationById',
    method: 'PUT',
    url: '/private/configuration/{id}',
    service: 'ui'
  },
  {
    name: 'patchConfigurationCloneById',
    method: 'PATCH',
    url: '/private/configuration/clone/{id}',
    service: 'ui'
  },
  {
    name: 'patchConfigurationPublishById',
    method: 'PATCH',
    url: '/private/configuration/publish/{id}',
    service: 'ui'
  },
  {
    name: 'getConfiguration',
    method: 'GET',
    url: '/private/configuration',
    service: 'ui'
  },
  {
    name: 'getConfigurationByMotherAgentId',
    method: 'GET',
    url: '/private/configuration/mother-agent/{motherAgentId}',
    service: 'ui'
  },
  {
    name: 'postConfiguration',
    method: 'POST',
    url: '/private/configuration',
    service: 'ui'
  },
  {
    name: 'postConfigurationForMotherAgent',
    method: 'POST',
    url: '/private/configuration/{id}/mother-agent/{motherAgentId}',
    service: 'ui'
  },
  {
    name: 'getPublicConfigurationById',
    method: 'GET',
    url: '/public/configuration/{id}',
    service: 'ui'
  }
];
